import { render, staticRenderFns } from "./Pagination.component.vue?vue&type=template&id=3ccb0dc7&scoped=true&"
import script from "./Pagination.component.vue?vue&type=script&lang=js&"
export * from "./Pagination.component.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.component.vue?vue&type=style&index=0&id=3ccb0dc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb0dc7",
  null
  
)

export default component.exports